import { WEEKDAY_LABELS } from "@/pages/Comercial/workingTimeConstants";
import { Box, Checkbox, FormControlLabel } from "@mui/material";
import { useEffect, useState } from "react";

interface NewOneProps {}

const NewOne = (props: NewOneProps) => {
  const [activatedWeekdays, setActivatedWeekdays] = useState([
    true,
    true,
    true,
    true,
    true,
    false,
    false,
  ]);

  const handleOnChange = (newIndex: number) =>
    setActivatedWeekdays((prevState) =>
      prevState.map((isActive, index) =>
        index === newIndex ? !isActive : isActive
      )
    );

  return (
    <Box>
      {activatedWeekdays.map((isActivated, index) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={isActivated}
              onChange={() => handleOnChange(index)}
            />
          }
          label={WEEKDAY_LABELS[index]}
        />
      ))}
    </Box>
  );
};

export default NewOne;
